export const SET_AMERICAN_INDIAN_OR_ALASKA_NATIVE =
  "SET_AMERICAN_INDIAN_OR_ALASKA_NATIVE";
export const SET_ASIAN = "SET_ASIAN";
export const SET_BLACK_OR_AFRICAN_AMERICAN = "SET_BLACK_OR_AFRICAN_AMERICAN";
export const SET_HISPANIC_OR_LATIN = "SET_HISPANIC_OR_LATIN";
export const SET_NATIVE_HAWAIIAN_OR_OTHER_PACIFIC_ISLANDER =
  "SET_NATIVE_HAWAIIAN_OR_OTHER_PACIFIC_ISLANDER";
export const SET_WHITE = "SET_WHITE";
export const SET_MIXED_RACE = "SET_MIXED_RACE";
export const SET_OTHER = "SET_OTHER";
export const SET_ETHNICITY_STATE = "SET_ETHNICITY_STATE";
